// extracted by mini-css-extract-plugin
export var actions = "_kt-d";
export var benefitCard = "_kt-a";
export var benefitIcon = "_kt-b";
export var benefitLabel = "_kt-c";
export var benefits = "_kt-9";
export var bodyText = "_kt-8";
export var closeButton = "_kt-2";
export var content = "_kt-3";
export var eyebrow = "_kt-4";
export var heading = "_kt-5";
export var image = "_kt-f";
export var imagePanel = "_kt-e";
export var modal = "_kt-0";
export var shell = "_kt-1";
export var title = "_kt-6";
export var titleOffer = "_kt-7";